import { Fragment } from 'react';
import { AirCheckoutFareNodeTypeEnum, IAirCheckoutFareBreakupNode } from 'obt-common';
import Divider from '@spotnana/pixel-react/dist/Divider';
import FareBreakupLoading from 'src/v1-components/trips/details/shared/FareBreakupLoading';
import Heading from './Heading';
import Normal from './Normal';
import OnlyValue from './OnlyValue';
import SubHeading from './SubHeading';
import { Info } from './Info';

interface IProps {
  breakupData: IAirCheckoutFareBreakupNode[];
  isFareBreakupLoading?: boolean;
}

const FareBreakup = ({ breakupData, isFareBreakupLoading = false }: IProps) => {
  const getComponent = (component: IAirCheckoutFareBreakupNode) => {
    const { type } = component;

    if (type === AirCheckoutFareNodeTypeEnum.DIVIDER) {
      return <Divider />;
    }

    switch (component.type) {
      case AirCheckoutFareNodeTypeEnum.HEADING:
        return <Heading label={component.label} value={component.value} />;
      case AirCheckoutFareNodeTypeEnum.SUB_HEADING:
        return (
          <SubHeading
            label={component.label}
            value={component.value}
            subTextLeft={component.subTextLeft}
            subTextRight={component.subTextRight}
          />
        );
      case AirCheckoutFareNodeTypeEnum.NORMAL:
        return (
          <Normal
            label={component.label}
            value={component.value}
            subTextLeft={component.subTextLeft}
            subTextRight={component.subTextRight}
            toolTipText={component.toolTipText}
            colorVariant={component.colorVariant}
          />
        );
      case AirCheckoutFareNodeTypeEnum.ONLY_VALUE:
        return <OnlyValue value={component.value} />;
      case AirCheckoutFareNodeTypeEnum.INFO:
        return <Info text={component.text} />;
      default:
        return null;
    }
  };
  if (isFareBreakupLoading) {
    return <FareBreakupLoading breakupData={breakupData} />;
  }

  return (
    <dl>
      {breakupData.map((fareComponent, index) => {
        return <Fragment key={index}>{getComponent(fareComponent)}</Fragment>;
      })}
    </dl>
  );
};

export default FareBreakup;
